import Button from "@mui/material/Button";
import styled from "@emotion/styled";

export const ButtonMG = styled(Button)`
  font-weight: bold;
  color: #fff;
`;
